import { getLabel } from './hosts';

const DEFAULT_LOCALE = 'en';

const LOCALES = {
  bdo: 'en',
};

export const getDefaultLocale = () => LOCALES[getLabel()] || DEFAULT_LOCALE;
